import PlexusCanvas from '../atoms/plexus-canvas.component';

type Props = {
  isTecimac?: boolean,
}

const CONTACT_DATA = {
  tecnocom: {
    address: [
      'Av. Paseo del Atlántico No. 6056, Marina Mazatlán,',
      'El Encanto Business Center, Local 81. C.P 82103.',
    ],
    phone: '669 105 9269',
    emails: ['tecnocommzt@outlook.com', 'contacto@tecnocommzt.com'],
  },
  tecimac: {
    address: [
      'C. Cruz Valle Verde 20, Oficina 2, Santa Cruz del Monte,',
      '53110 Naucalpan, Estado de México.',
    ],
    phone: '55 8926 2176',
    emails: ['contacto@tecimac.com'],
  },
};

const Footer = ({ isTecimac = false }: Props) => {
  const data = isTecimac ? CONTACT_DATA.tecimac : CONTACT_DATA.tecnocom;
  return (
    <footer className="footer">
      <PlexusCanvas side="right" className="footer__shader" />

      <div className="footer__inner">
        <div className="footer__item">
          <span className="footer__icon">
            <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="footer__text">
            <span>{data.address[0]}</span>
            <span>{data.address[1]}</span>
          </span>
        </div>

        <div className="footer__item">
          <span className="footer__icon">
            <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.896-1.587-5.25-3.941-6.837-6.837l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span>{data.phone}</span>
        </div>

        <div className="footer__item">
          <span className="footer__icon">
            <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="footer__text">
            {data.emails.map((email) => (
              <span key={email}>{email}</span>
            ))}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
